import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  bookAppointmentTimeslotRequest: ["childId", "categoryId", "timeslotId"],
  bookAppointmentTimeslotSuccess: ["status"],
  bookAppointmentTimeslotFailure: ["status"],
});

export const BookAppointmentTimeslotTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  childId: null,
  categoryId: null,
  timeslotId: null,
  fetching: null,
  success: null,
  status: null,
  error: null,
});

export const BookAppointmentTimeslotSelectors = {
  getData: (state: any) => state.bookAppointmentTimeslot.data,
  isFetching: (state: any) => state.bookAppointmentTimeslot.fetching,
  isSuccess: (state: any) => state.bookAppointmentTimeslot.success,
  hasError: (state: any) => state.bookAppointmentTimeslot.error,
};

export const request = (state: any, { childId, categoryId, timeslotId }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    childId,
    categoryId,
    timeslotId,
    status: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { status } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    status,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any, action: any) => {
  const { status } = action;
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    status: status,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.BOOK_APPOINTMENT_TIMESLOT_REQUEST]: request,
  [Types.BOOK_APPOINTMENT_TIMESLOT_SUCCESS]: success,
  [Types.BOOK_APPOINTMENT_TIMESLOT_FAILURE]: failure,
});
